import React, { useState, useContext, useEffect } from "react";
import api from '../../../services/api';
import Swal from "sweetalert2";
import { Header } from "../../../components/Header";
import { Menu } from "../../../components/Menu";
import { MenuPage } from "../../../components/MenuPage";
import { MobileContext } from "../../../contexts/MobileContext";
import { StyledCalendarioPage } from "../../../styled-components/StyledCalendarioPage.style";
import { getPeritos } from '../../../services/peritos';
import { ModalCalendarioIndisponibilidadesAdicionar } from "../../../components/ModalCalendarioIndisponibilidadesAdicionar";
import { ModalCalendarioIndisponibilidadesEditar } from "../../../components/ModalCalendarioIndisponibilidadesEditar";
import { ModalCalendarioIndisponibilidadesOcorrencias } from "../../../components/ModalCalendarioIndisponibilidadesOcorrencias";
import { ModalCalendarioIndisponibilidadesCancelar } from "../../../components/ModalCalendarioIndisponibilidadesCancelar";

export const CalendarioIndisponibilidades = () => {
    const isMobile = useContext(MobileContext);
    const isDesktop = !isMobile;

    const [modalAdicionar, setModalAdicionar] = useState(false);
    const [modalEditar, setModalEditar] = useState(false);
    const [modalOcorrencias, setModalOcorrencias] = useState(false);
    const [modalCancelar, setModalCancelar] = useState(false);
    const [idRegistroEdicao, setIdRegistroEdicao] = useState(null); 
    const [peritosList, setPeritosList] = useState([]);
    const [permissoes, setPermissoes] = useState(null);
    
    // Novos estados para a listagem principal
    const [ausenciasList, setAusenciasList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    // Função centralizada para carregar TUDO (Peritos e Ausências)
    const carregarDados = async () => {
        setIsLoading(true);
        try {
            const [peritosData, ausenciasResponse] = await Promise.all([
                getPeritos(),
                api.get('WipFeriasAusencias/list')
            ]);

            setPeritosList(peritosData || []);
            setAusenciasList(ausenciasResponse.data.data || []);
            setPermissoes(ausenciasResponse.data.access || null);
        } catch (error) {
            console.error("Erro ao carregar os dados:", error);
            Swal.fire('Erro', 'Não foi possível carregar a lista de indisponibilidades.', 'error');
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        carregarDados();
    }, []);

    const openModalAdicionar = () => {
        setModalAdicionar(true);
    }
    const closeModalAdicionar = () => {
        setModalAdicionar(false);
        carregarDados(); // Recarrega a tabela após adicionar
    }

    const openModalEditar = (idFeriasAusencias) => {
        setIdRegistroEdicao(idFeriasAusencias);
        setModalEditar(true);
    }
    const closeModalEditar = () => {
        setModalEditar(false);
        carregarDados();
    }

    const openModalCancelar = (idFeriasAusencias) => {
        setIdRegistroEdicao(idFeriasAusencias);
        setModalCancelar(true);
    }
    const closeModalCancelar = () => {
        setModalCancelar(false);
        carregarDados();
    }

    const openModalOcorrencias = (idFeriasAusencias) => {
        setIdRegistroEdicao(idFeriasAusencias);
        setModalOcorrencias(true);
    }
    const closeModalOcorrencias = () => {
        setModalOcorrencias(false);
    }

    // Helper: Pega o nome cruzando com o array de peritos. 
    // Nota: Ajuste "p.id" e "p.nome" conforme o retorno real do seu getPeritos()
    const getNomeProfissional = (idProfissional) => {
        if (!peritosList || peritosList.length === 0) return "Carregando...";
        const perito = peritosList.find(p => p.id === idProfissional || p.idUsuarioProfissional === idProfissional);
        return perito ? (perito.nome || perito.nomeProfissional) : "Profissional não encontrado";
    };

    // Helper: Formata a data (yyyy-MM-dd) para (dd/MM/yyyy) sem sofrer com timezone
    const formatarData = (dataIso) => {
        if (!dataIso) return "";
        const dataApenas = dataIso.split('T')[0];
        const [ano, mes, dia] = dataApenas.split('-');
        return `${dia}/${mes}/${ano}`;
    };

    return (
        <section>
            <main className="d-flex">
                {(() => {
                    if (isDesktop) {
                        return (
                            <Menu></Menu>
                        )
                    }
                    return null
                })()}
                <StyledCalendarioPage style={{ overflowX: 'hidden', width: '100%' }}>
                    <div className="w-100 d-flex justify-content-between align-items-center">
                        <div className="title-row">
                            <h5 className="title-row-header m-0">Calendário de Férias / Ausências</h5>
                        </div>
                    </div>
                    <div className="card py-1 px-2 mt-2">
                        <div className="row justify-content-between mb-3">
                            <div className="col-sm-12 col-md-2 col-lg-2  pt-2">
                                <input type="button" className='default-button-red-block btn-block' value='Adicionar' onClick={() => openModalAdicionar()} />
                            </div>
                        </div>
                        <p>Esta página exibe o calendário de indisponibilidades importantes para a empresa.</p>

                        <div className="table-scroll font-0-9x table-bordered table-container">
                            <table className="table table-width">
                                <thead>
                                    <tr className="table-legend-info">
                                        <th style={{width: '10%'}} key="ac">Ações</th>
                                        <th style={{width: '30%'}} key="nomePrograma">Profissional</th>
                                        <th style={{width: '30%'}} key="tipo">Tipo</th>
                                        <th style={{width: '10%'}} key="dataInicio">Data Início</th>
                                        <th style={{width: '10%'}} key="dataFim">Data Fim</th>
                                        <th style={{width: '10%'}} key="dataFim">Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {isLoading ? (
                                        <tr>
                                            <td colSpan="5" className="text-center py-3">Carregando dados...</td>
                                        </tr>
                                    ) : ausenciasList.length === 0 ? (
                                        <tr>
                                            <td colSpan="5" className="text-center py-3">Nenhuma indisponibilidade cadastrada.</td>
                                        </tr>
                                    ) : (
                                        ausenciasList.map((item) => (
                                            <tr key={item.idFeriasAusencias}>
                                                <td className="text-left">
                                                    <span className="cursor-pointer color-icon-default m-1" onClick={() => openModalOcorrencias(item.idFeriasAusencias)} title="Ocorrências">
                                                        <i className="fa fa-comments-o"></i>
                                                    </span>

                                                    { item.status && permissoes?.isEditarExpirados ? (
                                                        <span className="cursor-pointer color-icon-default m-1" onClick={() => openModalEditar(item.idFeriasAusencias)} title="Editar">
                                                            <i className="fa fa-edit" aria-hidden="true"></i>
                                                        </span>
                                                    ) : null}

                                                    { item.status && permissoes?.isCancelar ? (
                                                        <span className="cursor-pointer color-icon-default m-1" onClick={() => openModalCancelar(item.idFeriasAusencias)} title="Cancelar">
                                                            <i className="fa fa-ban" aria-hidden="true"></i>
                                                        </span>
                                                    ) : null}
                                                </td>
                                                <td>{item.nomeProfissional}</td>
                                                <td>{item.tipoDescricao}</td>
                                                <td>{formatarData(item.dataInicio)}</td>
                                                <td>{formatarData(item.dataFim)}</td>
                                                <td>
                                                    {!item.status ? (
                                                        <span className="badge bg-danger">Cancelado</span>
                                                    ) : new Date(item.dataFim) < new Date().setHours(0, 0, 0, 0) ? (
                                                        <span className="badge bg-secondary">Expirado</span>
                                                    ) : (
                                                        <span className="badge bg-success">Ativo</span>
                                                    )}
                                                </td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <ModalCalendarioIndisponibilidadesAdicionar
                        key={"ModalCalendarioFeriadosEventosAdicionar"}
                        profissionaisList={peritosList}
                        isOpen={modalAdicionar}
                        setIsOpen={() => setModalAdicionar(false)}
                        onRequestClose={closeModalAdicionar}
                    >
                    </ModalCalendarioIndisponibilidadesAdicionar>

                    <ModalCalendarioIndisponibilidadesEditar
                        key={"ModalCalendarioFeriadosEventosEditar"}
                        registroEdicao={idRegistroEdicao}
                        isOpen={modalEditar}
                        setIsOpen={() => setModalEditar(false)}
                        onRequestClose={closeModalEditar}
                        profissionaisList={peritosList} 
                    >
                    </ModalCalendarioIndisponibilidadesEditar>

                    <ModalCalendarioIndisponibilidadesCancelar
                        key={"ModalCalendarioFeriadosEventosCancelar"}
                        registroEdicao={idRegistroEdicao}
                        isOpen={modalCancelar}
                        setIsOpen={() => setModalCancelar(false)}
                        onRequestClose={closeModalCancelar}
                        profissionaisList={peritosList} 
                    >
                    </ModalCalendarioIndisponibilidadesCancelar>

                    <ModalCalendarioIndisponibilidadesOcorrencias
                        key={"ModalCalendarioFeriadosEventosOcorrencias"}
                        registroEdicao={idRegistroEdicao}
                        isOpen={modalOcorrencias}
                        setIsOpen={() => setModalOcorrencias(false)}
                        onRequestClose={closeModalOcorrencias}
                        profissionaisList={peritosList} 
                    >
                    </ModalCalendarioIndisponibilidadesOcorrencias>
                </StyledCalendarioPage>
            </main>
        </section>
    );
}

export const CalendarioIndisponibilidadesPage = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    return (
        <>
            {isMenuOpen ? (
                <MenuPage
                    isMenuOpen={isMenuOpen}
                    setIsMenuOpen={setIsMenuOpen}
                />
            ) : (
                <>
                    <Header
                        isMenuOpen={isMenuOpen}
                        setIsMenuOpen={setIsMenuOpen}
                    />
                    <CalendarioIndisponibilidades />
                </>
            )}
        </>
    );
}